export const Pages = {
  // System
  ROOT: '/',
  AUTH_CALLBACK: '/callback',
  NO_PERMISSIONS: '/wait',
  NOT_AUTHORIZED: '/not-authorized',
  NOT_FOUND: 'not-found',
  CHANGE_PASSWORD: 'profile/change-password',
  ONBOARDING: '/onboarding',
  ORGANIZATIONS: '/organizations',
  SETUP_API_KEYS: '/setup-api-keys',
  EMPLOYEES_PART: 'employees',
  SUBDIVISIONS_PART: 'subdivisions',
  ADMIN_SERVICE: '/admin',
  REFERENCE_BOOKS: 'reference-books',
  METERING_DEVICE_TYPES: 'metering-device-types',
  USERS: 'users',
  API_KEYS: 'api-keys',
  // Moved from BMS with BMS's paths (PO, 2026-10-27)
  DISTRIBUTION_TARIFF: 'distribution-tariff',
  WORKING_PERIODS: 'working-periods',
  WORKING_PERIODS_MAIN_ORGANIZATION: 'working-periods-main-organization',
  SUBSYSTEMS: 'subsystems',
} as const;

export type Pages = (typeof Pages)[keyof typeof Pages];
